module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vrassets/_next/static/images/no-image-available-300-b0c261d34051cc86c9654e3defeebe57.png";